function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.776 6.597a.831.831 0 011.171-.097c.464.394.9.795 1.307 1.2a.831.831 0 11-1.172 1.18c-.377-.375-.78-.747-1.21-1.111a.831.831 0 01-.096-1.172z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.663 24C2.663 12.216 12.216 2.663 24 2.663c3.888 0 7.53 1.039 10.668 2.854a.831.831 0 00.833-1.44A22.891 22.891 0 0024 1C11.297 1 1 11.297 1 24v.137c.03 4.926 1.892 10.069 4.293 13.262.132.176.323.306.544.31.214.006.485-.03.663-.209.375-.375.303-.75.244-.914a.684.684 0 00-.094-.163A21.24 21.24 0 012.663 24zM45.337 24c0 11.784-9.553 21.337-21.337 21.337a21.26 21.26 0 01-8.866-1.923.622.622 0 00-.282-.067c-.222.01-.637.092-.844.553-.225.5.19.884.392 1.032a.999.999 0 00.211.115C17.36 46.198 20.85 47 24 47c12.703 0 23-10.297 23-23 0-2.503-.66-5.235-1.494-7.598-.835-2.363-1.871-4.434-2.68-5.618a.831.831 0 00-1.373.938c.705 1.032 1.683 2.963 2.485 5.233.801 2.27 1.4 4.803 1.4 7.045z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.924 41.623a.831.831 0 01-1.167.145c-.48-.374-.931-.757-1.356-1.145a.831.831 0 011.123-1.226c.392.359.81.713 1.255 1.06a.831.831 0 01.145 1.166zM33.566 12.961a.821.821 0 01.02 1.162l-1.449 1.497a.821.821 0 11-1.18-1.142l1.448-1.498a.821.821 0 011.161-.019zm5.366 3.742a.821.821 0 01.048 1.16L22.615 35.63a1.643 1.643 0 01-2.419-.002L9.731 24.233c-.58-.631-.577-1.601.005-2.229l3.608-3.888c.654-.705 1.77-.7 2.418.01l5.66 6.207 6.463-6.68a.822.822 0 011.18 1.142l-6.461 6.68a1.643 1.643 0 01-2.395-.035l-5.66-6.207-3.608 3.889 10.465 11.395L37.771 16.75a.821.821 0 011.161-.047z",
  fill: "#2D2D2D"
});

function SvgComplexCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/complex-check.svg";
export { SvgComplexCheck as ReactComponent };